import { api } from './client';

export type Nivel =
  | 'vermelho'
  | 'laranja'
  | 'amarelo'
  | 'verde'
  | 'azul'
  | 'anil'
  | 'violeta';

export interface TierInfo {
  name: Nivel;
  color: string;
  min_kwh: number;
  max_kwh: number | null;
  percent: number;
}

export interface AllianceRuleOut {
  version: number;
  tiers: Array<{
    name: Nivel;
    color: string;
    min_kwh: number;
    max_kwh: number | null;
    percent: number;
  }>;
  window_days: number;
  valid_from: string;
  valid_until: string | null;
}

export interface MembershipOut {
  user_id: string;
  ativa: boolean;
  aderida_em: string;
  cancelada_em: string | null;
  termo_versao: string;
  nivel: Nivel;
  bonus_alianca_pct: number;
  kwh_acumulados_90d: string; // decimal string
  ultima_recarga_em: string | null;
  rule_version: number;
}

export interface TermoVigenteOut {
  version: string;
  body_md: string;
  summary: string;
  published_at: string;
}

export interface MeOut {
  adesao_disponivel: boolean;
  membership: MembershipOut | null;
  rule: AllianceRuleOut | null;
  proximo_nivel: TierInfo | null;
  kwh_faltam_proximo_nivel: string | null;
  termo_vigente: TermoVigenteOut | null;
}

export interface LevelChangeOut {
  id: string;
  from_nivel: Nivel;
  to_nivel: Nivel;
  direction: 'up' | 'down' | 'same';
  kwh_at_change: string;
  reason: string;
  created_at: string;
}

export interface AllianceStatsOut {
  total_recargas_desde_adesao: number;
  total_kwh_desde_adesao: string;
  bonus_extra_acumulado_brl: string;
  aderida_em: string;
}

// Cores Bow oficiais por nível (§7.1 do plano). Source of truth no tailwind.
export const NIVEL_TAILWIND_BG: Record<Nivel, string> = {
  vermelho: 'bg-bow-red',
  laranja: 'bg-bow-orange',
  amarelo: 'bg-bow-yellow',
  verde: 'bg-bow-green',
  azul: 'bg-bow-blue',
  anil: 'bg-bow-indigo',
  violeta: 'bg-bow-purple'
};

export const NIVEL_HEX: Record<Nivel, string> = {
  vermelho: '#EE263E',
  laranja: '#DE7C00',
  amarelo: '#FFB92A',
  verde: '#00C072',
  azul: '#0090E2',
  anil: '#835DD0',
  violeta: '#8345BA'
};

export async function getMe(): Promise<MeOut> {
  return api.get<MeOut>('/alianca/me');
}

export async function getStats(): Promise<AllianceStatsOut> {
  return api.get<AllianceStatsOut>('/alianca/stats');
}

export async function postAdesao(termoVersaoAceita: string): Promise<MembershipOut> {
  return api.post<MembershipOut>('/alianca/adesao', {
    termo_versao_aceita: termoVersaoAceita
  });
}

export async function deleteAdesao(): Promise<void> {
  await api.del<void>('/alianca/adesao');
}

export async function getUnreadLevelChanges(): Promise<LevelChangeOut[]> {
  return api.get<LevelChangeOut[]>('/alianca/level-changes/unread');
}

export async function ackLevelChange(id: string): Promise<void> {
  await api.post<void>(`/alianca/level-changes/${id}/ack`);
}
